import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { HpSharedModuleContainer } from '../HpSharedModuleContainer/HpSharedModuleContainer';
import { HpRespEditorialModuleItem } from './HpRespEditorialModuleItem';
import { trackEditorialImpressions, trackEditorialClick } from './helpers/EditorialTracking';
import { HpSharedInViewport } from '../HpSharedInViewport/HpSharedInViewport';

class HpRespEditorialModuleComponent extends Component {
    items = get(this.props, 'homepage.editorialModule.items');

    handleInitialDisplay = ({ inViewport }) => {
        if (this.items && inViewport) {
            trackEditorialImpressions(this.items);
        }
    };

    render() {
        if (!this.items) {
            return null;
        }

        return (
            <HpSharedModuleContainer addTopGap>
                <HpSharedInViewport
                    stopWhenInViewport
                    onInViewportChange={this.handleInitialDisplay}
                >
                    <div className="rowFlex" data-tn="editorial-wrapper">
                        {this.items.map((item, index) => (
                            <HpRespEditorialModuleItem
                                key={item.cmsId}
                                item={item}
                                onClick={() => trackEditorialClick(item, index)}
                            />
                        ))}
                    </div>
                </HpSharedInViewport>
            </HpSharedModuleContainer>
        );
    }
}

HpRespEditorialModuleComponent.propTypes = {
    homepage: PropTypes.object.isRequired,
};

export const HpRespEditorialModule = createFragmentContainer(HpRespEditorialModuleComponent, {
    homepage: graphql`
        fragment HpRespEditorialModule_homepage on Homepage {
            editorialModule: module(type: "editorial") {
                ... on EditorialModule {
                    items {
                        cmsId
                        cta
                        description
                        link
                        imageUrl
                    }
                }
            }
        }
    `,
});
